module.exports = __webpack_public_path__ + "img/MA-HMI-4.29c4be81.png";